// User Management Utility Functions

export const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
export const ROWS_PER_PAGE = 10;

export const ROLE_NAMES = {
  MANAGER: "manager",
  TECHNICIAN: "technician",
  SUPERVISOR: "supervisor",
};

export const TABS = [
  "Department",
  "Division",
  "Manager",
  "Supervisor",
  "Technician",
];

// Validation functions
export const isValidEmail = (email) => {
  return EMAIL_REGEX.test(email);
};

// Data transformation functions
export const getAcademyName = (academyId, academies) => {
  const academy = academies?.find((a) => a.academyId === academyId);
  return academy ? academy.name : "Unknown Academy";
};

export const getDepartmentName = (departmentId, departments) => {
  const department = departments?.find((d) => d.departmentId === departmentId);
  return department ? department.name : "Unknown department";
};

export const getDivisionName = (divisionId, divisions) => {
  if (!divisionId) return "N/A";
  const division = divisions?.find((d) => d.divisionId === divisionId);
  return division?.name || "N/A";
};

export const truncateText = (text, maxLength) => {
  if (!text) return "";
  return text.length > maxLength ? text.substring(0, maxLength) + "..." : text;
};

// Data filtering functions
export const filterData = (data, searchTerm) => {
  const searchLower = searchTerm.toLowerCase();
  return data.filter((item) =>
    Object.values(item).some((value) =>
      (value !== null && value !== undefined
        ? value.toString().toLowerCase()
        : ""
      ).includes(searchLower)
    )
  );
};

// Pagination functions
export const getTotalPages = (dataLength, rowsPerPage = ROWS_PER_PAGE) => {
  return Math.ceil(dataLength / rowsPerPage);
};

export const getDisplayedData = (
  data,
  currentPage,
  rowsPerPage = ROWS_PER_PAGE
) => {
  return data.slice((currentPage - 1) * rowsPerPage, currentPage * rowsPerPage);
};

// Sorting functions
export const sortData = (data, column, ascending) => {
  return [...data].sort((a, b) => {
    let valA = a[column];
    let valB = b[column];

    if (valA === undefined || valA === null) valA = "";
    if (valB === undefined || valB === null) valB = "";

    if (!isNaN(valA) && !isNaN(valB)) {
      valA = Number(valA);
      valB = Number(valB);
    } else {
      valA = valA.toString().toLowerCase();
      valB = valB.toString().toLowerCase();
    }

    if (valA < valB) return ascending ? -1 : 1;
    if (valA > valB) return ascending ? 1 : -1;
    return 0;
  });
};
